var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGps = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 66,
  height: 66,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 33C0 14.775 14.775 0 33 0s33 14.775 33 33-14.775 33-33 33S0 51.225 0 33Z",
  fill: "#F2F4F8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m47.814 20.527-10.261 26.75a1.031 1.031 0 0 1-.96.66h-.071a1.031 1.031 0 0 1-.929-.793l-2.949-12.788-12.787-2.919a1.03 1.03 0 0 1-.134-1.959l26.75-10.292a1.031 1.031 0 0 1 1.34 1.34Z",
  fill: "#A2A9B0"
})));
export default SvgGps;